import { DatePickerDate } from '@smartsheet/lodestar-core';
import { utcToZonedTime } from 'date-fns-tz';
import i18n from '../../../../../../../i18n';
import { Option } from '../../../../../../../services/ducks/schedulesDuck';

export const locale = 'en';
export const timezone = 'UTC';

export type ScheduleStateType<T> = { value: T; valid: boolean };

export type ScheduleStateDatePickerType =
  ScheduleStateType<DatePickerDate | null>;
export type ScheduleStateStringType = ScheduleStateType<string>;
export type ScheduleStateSelectType = ScheduleStateType<Option | null>;

export const ScheduleFieldLabels = [
  i18n.t('designer:triggerPanel:schedules:upsert:startDate'),
  i18n.t('designer:triggerPanel:schedules:upsert:startTime'),
  i18n.t('designer:triggerPanel:schedules:upsert:run'),
  i18n.t('designer:triggerPanel:schedules:upsert:unit'),
  i18n.t('designer:triggerPanel:schedules:every'),
];

export const liveDateTimeStringFormat = `EEEE, MMMM d, yyyy '${i18n.t(
  'timeFormat:at'
)}' HH:mm:ss`;

export const isDurationValid = (
  duration: string,
  unit: Option | null
): string | undefined => {
  if (!duration) {
    return i18n.t('designer:triggerPanel:schedules:upsert:required');
  } else if (/^[0-9]*$/.test(duration) === false) {
    return i18n.t('designer:triggerPanel:schedules:upsert:everyInteger');
  } else if (duration.charAt(0) === '0') {
    return i18n.t('designer:triggerPanel:schedules:upsert:everyMinimum1');
  } else if (parseInt(duration) < 15 && unit?.value === 'minutes') {
    return i18n.t('designer:triggerPanel:schedules:upsert:everyMinutes');
  } else {
    return undefined;
  }
};

export const ALL_START_TIME_OPTIONS = [
  { label: i18n.t('timesPerFormat:24:0000'), value: '00:00' },
  { label: i18n.t('timesPerFormat:24:0015'), value: '00:15' },
  { label: i18n.t('timesPerFormat:24:0020'), value: '00:30' },
  { label: i18n.t('timesPerFormat:24:0045'), value: '00:45' },
  { label: i18n.t('timesPerFormat:24:0100'), value: '01:00' },
  { label: i18n.t('timesPerFormat:24:0115'), value: '01:15' },
  { label: i18n.t('timesPerFormat:24:0130'), value: '01:30' },
  { label: i18n.t('timesPerFormat:24:0145'), value: '01:45' },
  { label: i18n.t('timesPerFormat:24:0200'), value: '02:00' },
  { label: i18n.t('timesPerFormat:24:0215'), value: '02:15' },
  { label: i18n.t('timesPerFormat:24:0230'), value: '02:30' },
  { label: i18n.t('timesPerFormat:24:0245'), value: '02:45' },
  { label: i18n.t('timesPerFormat:24:0300'), value: '03:00' },
  { label: i18n.t('timesPerFormat:24:0315'), value: '03:15' },
  { label: i18n.t('timesPerFormat:24:0330'), value: '03:30' },
  { label: i18n.t('timesPerFormat:24:0345'), value: '03:45' },
  { label: i18n.t('timesPerFormat:24:0400'), value: '04:00' },
  { label: i18n.t('timesPerFormat:24:0415'), value: '04:15' },
  { label: i18n.t('timesPerFormat:24:0430'), value: '04:30' },
  { label: i18n.t('timesPerFormat:24:0445'), value: '04:45' },
  { label: i18n.t('timesPerFormat:24:0500'), value: '05:00' },
  { label: i18n.t('timesPerFormat:24:0515'), value: '05:15' },
  { label: i18n.t('timesPerFormat:24:0530'), value: '05:30' },
  { label: i18n.t('timesPerFormat:24:0545'), value: '05:45' },
  { label: i18n.t('timesPerFormat:24:0600'), value: '06:00' },
  { label: i18n.t('timesPerFormat:24:0615'), value: '06:15' },
  { label: i18n.t('timesPerFormat:24:0630'), value: '06:30' },
  { label: i18n.t('timesPerFormat:24:0645'), value: '06:45' },
  { label: i18n.t('timesPerFormat:24:0700'), value: '07:00' },
  { label: i18n.t('timesPerFormat:24:0715'), value: '07:15' },
  { label: i18n.t('timesPerFormat:24:0730'), value: '07:30' },
  { label: i18n.t('timesPerFormat:24:0745'), value: '07:45' },
  { label: i18n.t('timesPerFormat:24:0800'), value: '08:00' },
  { label: i18n.t('timesPerFormat:24:0815'), value: '08:15' },
  { label: i18n.t('timesPerFormat:24:0830'), value: '08:30' },
  { label: i18n.t('timesPerFormat:24:0845'), value: '08:45' },
  { label: i18n.t('timesPerFormat:24:0900'), value: '09:00' },
  { label: i18n.t('timesPerFormat:24:0915'), value: '09:15' },
  { label: i18n.t('timesPerFormat:24:0930'), value: '09:30' },
  { label: i18n.t('timesPerFormat:24:0945'), value: '09:45' },
  { label: i18n.t('timesPerFormat:24:1000'), value: '10:00' },
  { label: i18n.t('timesPerFormat:24:1015'), value: '10:15' },
  { label: i18n.t('timesPerFormat:24:1030'), value: '10:30' },
  { label: i18n.t('timesPerFormat:24:1045'), value: '10:45' },
  { label: i18n.t('timesPerFormat:24:1100'), value: '11:00' },
  { label: i18n.t('timesPerFormat:24:1115'), value: '11:15' },
  { label: i18n.t('timesPerFormat:24:1130'), value: '11:30' },
  { label: i18n.t('timesPerFormat:24:1145'), value: '11:45' },
  { label: i18n.t('timesPerFormat:24:1200'), value: '12:00' },
  { label: i18n.t('timesPerFormat:24:1215'), value: '12:15' },
  { label: i18n.t('timesPerFormat:24:1230'), value: '12:30' },
  { label: i18n.t('timesPerFormat:24:1245'), value: '12:45' },
  { label: i18n.t('timesPerFormat:24:1300'), value: '13:00' },
  { label: i18n.t('timesPerFormat:24:1315'), value: '13:15' },
  { label: i18n.t('timesPerFormat:24:1330'), value: '13:30' },
  { label: i18n.t('timesPerFormat:24:1345'), value: '13:45' },
  { label: i18n.t('timesPerFormat:24:1400'), value: '14:00' },
  { label: i18n.t('timesPerFormat:24:1415'), value: '14:15' },
  { label: i18n.t('timesPerFormat:24:1430'), value: '14:30' },
  { label: i18n.t('timesPerFormat:24:1445'), value: '14:45' },
  { label: i18n.t('timesPerFormat:24:1500'), value: '15:00' },
  { label: i18n.t('timesPerFormat:24:1515'), value: '15:15' },
  { label: i18n.t('timesPerFormat:24:1530'), value: '15:30' },
  { label: i18n.t('timesPerFormat:24:1545'), value: '15:45' },
  { label: i18n.t('timesPerFormat:24:1600'), value: '16:00' },
  { label: i18n.t('timesPerFormat:24:1615'), value: '16:15' },
  { label: i18n.t('timesPerFormat:24:1630'), value: '16:30' },
  { label: i18n.t('timesPerFormat:24:1645'), value: '16:45' },
  { label: i18n.t('timesPerFormat:24:1700'), value: '17:00' },
  { label: i18n.t('timesPerFormat:24:1715'), value: '17:15' },
  { label: i18n.t('timesPerFormat:24:1730'), value: '17:30' },
  { label: i18n.t('timesPerFormat:24:1745'), value: '17:45' },
  { label: i18n.t('timesPerFormat:24:1800'), value: '18:00' },
  { label: i18n.t('timesPerFormat:24:1815'), value: '18:15' },
  { label: i18n.t('timesPerFormat:24:1830'), value: '18:30' },
  { label: i18n.t('timesPerFormat:24:1845'), value: '18:45' },
  { label: i18n.t('timesPerFormat:24:1900'), value: '19:00' },
  { label: i18n.t('timesPerFormat:24:1915'), value: '19:15' },
  { label: i18n.t('timesPerFormat:24:1930'), value: '19:30' },
  { label: i18n.t('timesPerFormat:24:1945'), value: '19:45' },
  { label: i18n.t('timesPerFormat:24:2000'), value: '20:00' },
  { label: i18n.t('timesPerFormat:24:2015'), value: '20:15' },
  { label: i18n.t('timesPerFormat:24:2030'), value: '20:30' },
  { label: i18n.t('timesPerFormat:24:2045'), value: '20:45' },
  { label: i18n.t('timesPerFormat:24:2100'), value: '21:00' },
  { label: i18n.t('timesPerFormat:24:2115'), value: '21:15' },
  { label: i18n.t('timesPerFormat:24:2130'), value: '21:30' },
  { label: i18n.t('timesPerFormat:24:2145'), value: '21:45' },
  { label: i18n.t('timesPerFormat:24:2200'), value: '22:00' },
  { label: i18n.t('timesPerFormat:24:2215'), value: '22:15' },
  { label: i18n.t('timesPerFormat:24:2230'), value: '22:30' },
  { label: i18n.t('timesPerFormat:24:2245'), value: '22:45' },
  { label: i18n.t('timesPerFormat:24:2300'), value: '23:00' },
  { label: i18n.t('timesPerFormat:24:2315'), value: '23:15' },
  { label: i18n.t('timesPerFormat:24:2330'), value: '23:30' },
  { label: i18n.t('timesPerFormat:24:2345'), value: '23:45' },
];

export const getHoursMinutesFromOptionValue = (value: string): number[] =>
  value.split(':').map(val => parseInt(val, 10));

export const isDateTimeInTheFuture = (
  date: DatePickerDate,
  hours: number,
  minutes: number,
  liveUTCDateTime: Date,
  timezone: string
): boolean =>
  liveUTCDateTime <
  utcToZonedTime(
    new Date(Date.UTC(date.year, date.month, date.day, hours, minutes)),
    timezone
  );

export const getValidationState = (valid: boolean) =>
  valid ? undefined : 'error';
